"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalTradesLabel = exports.ChunkSelector = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var context_1 = require("../context/context");
var hooks_1 = require("../hooks/hooks");
var styles_1 = require("../styles");
var base_1 = require("./base");
var lib_1 = require("../hooks/lib");
var ChunkSelector = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children;
    var shouldWrapOrUnwrapOnly = (0, lib_1.useShouldWrapOrUnwrapOnly)();
    if (shouldWrapOrUnwrapOnly) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(StyledChunkSelector, __assign({ className: className }, { children: [children, (0, jsx_runtime_1.jsx)(Text, {})] })));
};
exports.ChunkSelector = ChunkSelector;
var Text = function () {
    var _a = (0, context_1.useTwapContext)(), isWrongChain = _a.isWrongChain, srcToken = _a.srcToken, srcUsd = _a.srcUsd;
    var chunkSizeFormatted = (0, hooks_1.useFormatNumberV2)({ value: (0, lib_1.useSrcChunkAmount)().amountUi });
    var warning = (0, lib_1.useTradeSizeWarning)();
    var _usd = (0, hooks_1.useFormatNumberV2)({ value: (0, lib_1.useSrcChunkAmountUsd)(), decimalScale: 2 });
    var usd = _usd ? "($".concat(_usd, ")") : "";
    if (!srcUsd || isWrongChain)
        return null;
    return ((0, jsx_runtime_1.jsxs)(base_1.BottomContent, { children: [(0, jsx_runtime_1.jsx)(StyledMessage, { title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [chunkSizeFormatted, " ", srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol, " per trade ", (0, jsx_runtime_1.jsx)("span", { children: usd })] }) }), warning && (0, jsx_runtime_1.jsx)(StyledWarning, { variant: "warning", title: warning })] }));
};
var StyledWarning = (0, styled_components_1.default)(base_1.Message)({
    marginTop: 2,
});
var Input = function (_a) {
    var className = _a.className;
    var chunks = (0, lib_1.useChunks)();
    var setChunks = (0, lib_1.useSetChunks)();
    return (0, jsx_runtime_1.jsx)(StyledChunksInput, { className: className, placeholder: "0", value: chunks, decimalScale: 0, onChange: function (value) { return setChunks(Number(value)); } });
};
var SliderComponent = function (_a) {
    var className = _a.className;
    var chunks = (0, lib_1.useChunks)();
    var setChunks = (0, lib_1.useSetChunks)();
    var maxPossibleChunks = (0, lib_1.useMaxPossibleChunks)();
    var srcUsd = (0, context_1.useTwapContext)().srcUsd;
    if (!srcUsd) {
        return (0, jsx_runtime_1.jsx)(base_1.Loader, { height: "100%" });
    }
    return (0, jsx_runtime_1.jsx)(base_1.Slider, { className: className, min: 1, max: maxPossibleChunks === 1 ? maxPossibleChunks + 0.0001 : maxPossibleChunks, value: chunks, onChange: setChunks });
};
var StyledMessage = (0, styled_components_1.default)(base_1.Message)({
    span: {
        opacity: 0.7,
        fontSize: "13px",
    },
});
var TotalTradesLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.totalTrades }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: translations.totalTradesTooltip })] }));
};
exports.TotalTradesLabel = TotalTradesLabel;
exports.ChunkSelector.Slider = SliderComponent;
exports.ChunkSelector.Input = Input;
exports.ChunkSelector.Label = exports.TotalTradesLabel;
var StyledChunksInput = (0, styled_components_1.default)(base_1.NumericInput)({
    width: "100%",
    padding: "0px",
    input: {
        padding: "0px",
        textAlign: "right",
        width: "100%",
        transition: "0.2s all",
    },
});
var StyledChunkSelector = (0, styled_components_1.default)(styles_1.StyledColumnFlex)({
    gap: 0,
    ".twap-slider": {
        flex: 1,
        marginLeft: "auto",
        marginRight: "auto",
    },
});
